import React, { useState, useEffect, useRef } from "react";
import PostsList from "../../Components/ContactCenterComponents/PostsList";
import FormSection from "../../Components/ContactCenterComponents/FormSection";
import styled from "styled-components";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import "./ContactCenter.css";
import { getAllPosts } from "../../DataApi/contactCenter/allPostsApi";
import { getPostComments } from "../../DataApi/contactCenter/commentsApi";
import { addComment } from "../../DataApi/contactCenter/addCommentApi";
import facebook from "../../Images/facebook.png";
import instagram from "../../Images/instagram.png";
import twitter from "../../Images/twitter.png";
import pinterest from "../../Images/pinterest.png";
import reddit from "../../Images/reddit.png";
import { mediaProfiles } from "../../DataApi/contactCenter/getMediaProfiles";

const Container = styled.div`
  min-height: 100vh;
  background-color: #f3f4f6;
  padding: 2rem;
  margin: 30px;
  border-radius: 20px;
  @media (max-width: 425px) {
    margin: 6px;
    min-height: 100vh;
    background-color: #f3f4f6;
    padding: 2rem;
    border-radius: 20px;
  }
`;
const Grid = styled.div`
  display: grid;
  height: 100%;
  grid-template-columns: 1fr 2fr;
  grid-gap: 10px;
  @media (max-width: 425px) {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
  }
`;
const SocialProfiles = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  margin-bottom: 10px;
`;
const MediaImage = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  @media (max-width: 425px) {
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }
`;
const MediaTitle = styled.p`
  font-size: 12px;
  font-family: "Inter";
  font-weight: bold;
  margin-bottom: 0px;
  @media (max-width: 425px) {
    font-size: 8px;
  }
`;

const ContactCenter = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [postList, setPostList] = useState([]);
  const [commentsList, setCommentsList] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [mediaProfileNames, setMediaProfileNames] = useState({});
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);
  const [isLoadingComments, setIsLoadingComments] = useState(false);
  const [selectedPost, setSelectedPost] = useState({
    postDetail: null,
    id: null,
    platform: "",
  });
  const icons = { facebook, twitter, instagram, pinterest, reddit };
  const scrollRef = useRef(null);
  const getPosts = async () => {
    setIsLoadingPosts(true);
    try {
      let responsePosts = await getAllPosts();
      if (responsePosts) {
        responsePosts = JSON.parse(responsePosts);
        if (responsePosts?.result?.posts) {
          setPostList(responsePosts?.result?.posts || []);
        }
      }
    } catch (error) {
      console.error("Error fetching posts data:", error);
    } finally {
      setIsLoadingPosts(false);
    }
  };
  const getComments = async () => {
    setIsLoadingComments(true);
    try {
      const { id, platform } = selectedPost;
      let responseComments = await getPostComments({
        id,
        platform,
      });
      responseComments = JSON.parse(responseComments);
      if (responseComments?.result?.comments) {
        setCommentsList(responseComments?.result?.comments || []);
      }
    } catch (error) {
      console.error("Error fetching comments data:", error);
    } finally {
      setIsLoadingComments(false);
    }
  };
  const handlePlatformSelection = (platform) => {
    ("clicked platform");
    if (platform === selectedPlatform) {
      setSelectedPlatform("");
    } else if (selectedPlatform === "" || selectedPlatform != platform) {
      setSelectedPlatform(platform);
    }
  };
  const handleSendMessage = async (inputValue) => {
    setIsLoadingComments(true);
    try {
      const { id } = selectedPost;
      let trimmedInput = inputValue.trim();
      if (trimmedInput === "" && id === null) return;
      let newCommentResponse = await addComment({ trimmedInput, id });
      newCommentResponse = JSON.parse(newCommentResponse);
      if (newCommentResponse?.result?.status === "success") {
        const platform = selectedPost.platform;
        const commentData = newCommentResponse.result[platform];

        if (commentData) {
          let dateNow = new Date();
          const newComment = {
            author: mediaProfileNames
              ? mediaProfileNames[commentData?.platform]
              : null,
            comment: commentData?.comment || "",
            date: dateNow,
            id: commentData?.commentId || "",
            likes: 0,
          };
          setCommentsList((prevCommentsList) => [
            ...prevCommentsList,
            newComment,
          ]);
        }
        // getComments();
        if (scrollRef.current) {
          scrollRef.current.scrollTo(0, scrollRef.current.scrollHeight);
        }
        setInputValue("");
      }
    } catch (error) {
      console.error("Error adding comment:", error);
    } finally {
      setIsLoadingComments(false);
    }
  };
  const getMediaProfiles = async () => {
    let mediaResponse = await mediaProfiles();
    mediaResponse = JSON.parse(mediaResponse);
    if (mediaResponse?.result) {
      setMediaProfileNames(mediaResponse?.result || {});
    }
  };
  useEffect(() => {
    getPosts();
    getMediaProfiles();
  }, []);
  useEffect(() => {
    if (selectedPost.id && selectedPost.platform) {
      getComments();
    }
  }, [selectedPost]);
  return (
    <div style={{ height: "100vh" }}>
      <Container>
        <SocialProfiles className="socialProfiles">
          {mediaProfileNames &&
            Object.entries(mediaProfileNames).map(([platform, handle]) => (
              <div
                disabled={isLoadingPosts}
                key={platform}
                onClick={() => handlePlatformSelection(platform)}
                className={`d-flex flex-column justify-content-center align-items-center platformItem cursor-pointer ${
                  isLoadingPosts ? "opacity-50" : "opacity-100"
                } ${platform === selectedPlatform ? "selected" : ""}`}
              >
                <MediaImage src={icons[platform]} alt="social media img" />
                <MediaTitle>{handle}</MediaTitle>
              </div>
            ))}
        </SocialProfiles>
        <Grid>
          <PostsList
            posts={postList}
            setPostList={setPostList}
            setSelectedPost={setSelectedPost}
            selectedPost={selectedPost}
            selectedPlatform={selectedPlatform}
            isLoadingPosts={isLoadingPosts}
          />
          <FormSection
            postDetail={selectedPost}
            commentsData={commentsList}
            inputValue={inputValue}
            setInputValue={setInputValue}
            handleSendMessage={handleSendMessage}
            isLoadingComments={isLoadingComments}
            scrollRef={scrollRef}
            selectedPost={selectedPost}
          />
        </Grid>
      </Container>
    </div>
  );
};

export default ContactCenter;
